module.exports = __webpack_public_path__ + "img/img9.f885a603.png";